<template>
  <div v-if="totalAmountMeetsThreshold">
    <div v-if="financingOffersEnabled || paymentsAsLowAsEnabled">
      <Summary v-if="showSummary || !editable" data-cy="summary" />
      <QuoteDraft v-else data-cy="quoteDraft" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { watch } from "vue";

import { Quote } from "@/typings/quote";
import QuoteDraft from "./QuoteDraft.vue";
import Summary from "./Summary.vue";
import { useFinancingAvailable } from "./useFinancingAvailable";

const { init, totalAmountMeetsThreshold, showSummary } =
  useFinancingAvailable();

const props = defineProps({
  financingOffersEnabled: {
    type: Boolean,
    default: false
  },
  paymentsAsLowAsEnabled: {
    type: Boolean,
    default: false
  },
  quote: {
    type: Object as () => Quote,
    required: true
  },
  editable: {
    type: Boolean,
    default: false
  }
});

watch(
  () => JSON.stringify(props),
  (oldVal, newVal) => {
    if (oldVal === newVal) return;
    init(props);
  },
  { immediate: true }
);
</script>
